import{a as t}from"./chunk-D6FCK2GA.js";function u(r,n,o){let a=r.length-n.length;if(a===0)return r(...n);if(a===1)return t(r,n,o);throw new Error("Wrong number of arguments")}export{u as a};
